import { useState } from 'react';

import { Button } from '../ui/button';

/**
 * The only place a temporary password is ever visible. The server keeps just
 * its hash, so once this panel is closed nobody can read it again — the
 * warning says so, and closing is an explicit action.
 */
export function OneTimePasswordPanel({
  email,
  password,
  title,
  onClose,
}: {
  email: string;
  password: string;
  title: string;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div role="alertdialog" aria-label={title} className="rounded border border-amber-400 bg-amber-50 p-4 text-sm text-slate-900">
      <div className="mb-1 font-medium">{title}</div>
      <div className="mb-2 text-xs text-slate-700">{email}</div>
      <div
        data-testid="temp-password"
        className="mb-3 select-all rounded border border-amber-300 bg-white px-3 py-2 text-center font-mono text-lg tracking-wider"
      >
        {password}
      </div>
      <p className="mb-3 text-xs">
        <strong>Пароль показан один раз и больше не появится.</strong> Скопируйте его сейчас и передайте сотруднику
        лично или в защищённом мессенджере. При первом входе система потребует сменить пароль.
      </p>
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={() => void copy()}>
          {copied ? 'Скопировано' : 'Скопировать'}
        </Button>
        <Button size="sm" variant="secondary" onClick={onClose}>
          Я сохранил пароль, закрыть
        </Button>
      </div>
    </div>
  );
}
